import React from 'react';
import PropTypes from 'prop-types';
import last = require("lodash/last");
import GridComp, {BulkAction, ExpandComponentProps, UILOCATION} from 'core/grid/component/gridComp';
import Grid, {GridParams, GridRow} from "core/grid/domain/grid";
import {ObservableMap} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import Route = ReactRouter.Route;
import {observer} from "mobx-react";
import {ISECURABLE} from "core/metamodel/metaConstant";

interface GridCompConnectedProps {
  gridId: number;
  query: any;
  grid: Grid,
  entities: ObservableMap<MdEntity>;
  bulkActions?: BulkAction[];
  multiUpdateSecurable?: ISECURABLE;

  // if true, rows are expandable
  showExpand?: boolean;

  ExpandComponent?: React.ComponentClass<ExpandComponentProps>;

  multiDeleteSecurable? : ISECURABLE;
  multiDeleteSaveFn?: (gridParams: GridParams) => Promise<any>;

  // pokud grid ma refreshOnData na vice entit;
  refreshEntities?: string[];

}

@observer
export default class GridCompConnected extends React.Component<GridCompConnectedProps, undefined> {

  static contextTypes = {
    router: PropTypes.func.isRequired
  };

  private _gridCompRef: GridComp;

  constructor(props) {
    super(props);
    console.debug('GridCompConnected#constructor, props: %o', props);
  }

  onGridChange = (grid: Grid) => {
    console.debug('onGridChange(%o)', grid);

    const routeName = last<Route>(this.context.router.getCurrentRoutes()).name,
      params = this.context.router.getCurrentParams();

    if (grid.activeGridConfig) params.gridId = grid.activeGridConfig.gridId;

    let query = grid.createParams();

    console.debug('replaceWith %s, %o, %o', routeName, params, query);

    this.context.router.replaceWith(routeName, params, query);
  };


  componentWillMount() {
    console.debug('GridCompConnected#componentWillMount(), props: %o', this.props);

    let {query, grid} = this.props;

    grid.data = null;
    grid.searchTerm = query.searchTerm || '';
    grid.assignActiveGridConfig(grid.getActiveGridConfig(this.props.gridId));

    if (query.sort) grid.sort = query.sort;

    console.log(grid.activeGridConfig);

    grid.setConditionQueryObject(query);

    if (query.specialConditions) {
      grid.specialConditions = query.specialConditions.map( (scId: number) => grid.$gridLocationRef.specialConditions.find((sc) => sc.value == scId)) // pozor musi byt ==, protoze scId je string
        .filter((sc) => sc);
    }
    console.log("query.specialConditions = %O, grid.specialConditions = %O, grid.$gridLocationRef.specialConditions = %O",
      query.specialConditions, grid.specialConditions, grid.$gridLocationRef.specialConditions);
  }

  componentDidMount() {
    let {grid} = this.props;
    if (grid.activeGridConfig && !grid.activeGridConfig.refreshOnPage) {
      return;
    }
    this._gridCompRef.search();
  }

  // componentWillUnmount() {
  //   console.log('componentWillUnmount');
  //   GridService.removeGrid(this.props.grid.gridLocation);
  // }


  gridCompRef = (comp) => {
    this._gridCompRef = comp;
  };



  render() {
    let {grid, entities, bulkActions, children, multiUpdateSecurable, showExpand, ExpandComponent, multiDeleteSecurable, multiDeleteSaveFn, refreshEntities} = this.props;

    //console.debug('GridCompConnected#render, props: %o', this.props);
    return (
      <GridComp ref={this.gridCompRef} grid={grid} uiLocation={UILOCATION.page} onGridChange={this.onGridChange} entities={entities} bulkActions={bulkActions}
                multiUpdateSecurable={multiUpdateSecurable} showExpand={showExpand} ExpandComponent={ExpandComponent}
                multiDeleteSecurable={multiDeleteSecurable} multiDeleteSaveFn={multiDeleteSaveFn} refreshEntities={refreshEntities}>
        {children}
      </GridComp>
    );
  }


}




// WEBPACK FOOTER //
// ./src/core/grid/component/gridCompConnected.tsx